'use strict';

var MarketProductGroupDateRangeFilterFactory = function MarketProductGroupDateRangeFilterFactory(DataRangeFilter) {
  function MarketProductGroupDateRangeFilter() {
    this.sourceType = ['market-product-group', 'market'];
    this.filterType = 'dateRange';
  }
  MarketProductGroupDateRangeFilter.constructor = MarketProductGroupDateRangeFilter;
  MarketProductGroupDateRangeFilter.prototype = Object.create(DataRangeFilter.prototype);
  MarketProductGroupDateRangeFilter.prototype.groupBy = 'departureDateMoment';
  return MarketProductGroupDateRangeFilter;
};
MarketProductGroupDateRangeFilterFactory.$inject = ['DataRangeFilterFactory'];
module.exports = MarketProductGroupDateRangeFilterFactory;